export const classes = {
	articleDetail: '/api/insureapi/officialIndexService/articleDetail',
  getDetailByIds: '/api/insureapi/officialIndexService/getDetailByIds',
	categoryArticle: '/api/insureapi/officialIndexService/categoryArticle',
	hotArticle: '/api/insureapi/officialIndexService/hotArticle',
	hotTag: '/api/insureapi/officialIndexService/hotTag',
	index: '/api/insureapi/officialIndexService/index',
	indexCategory: '/api/insureapi/officialIndexService/indexCategory',
	searchArticle: '/api/insureapi/officialIndexService/searchArticle',
	latestArticle: '/api/insureapi/officialIndexService/latestArticle',
	newTagList: '/api/insureapi/officialIndexService/newTagList',
	relatedArticle: '/api/insureapi/officialIndexService/relatedArticle',
	yourFavorite: '/api/insureapi/officialIndexService/yourFavorite',
	categoryTree: '/api/insureapi/officialIndexService/categoryTree',
	nearbyArticle: '/api/insureapi/officialIndexService/nearbyArticle',
	tagArticleList: '/api/insureapi/officialIndexService/tagArticleList',
	preViewArticleDetail: '/api/insureapi/officialIndexService/preViewArticleDetail',
	hotSearch: '/api/insureapi/officialIndexService/hotSearch',
	pageInfo: '/api/insureapi/officialIndexService/pageInfo',
  // 问答
  qa_detail: '/api/insureapi/officialQaIndexService/qaDetail',
  qa_getDetailByIds: '/api/insureapi/officialQaIndexService/getDetailByIds',
  qa_categoryArticle: '/api/insureapi/officialQaIndexService/categoryArticle',
  qa_hotArticle: '/api/insureapi/officialQaIndexService/hotArticle',
  qa_hotTag: '/api/insureapi/officialQaIndexService/hotTag',
  qa_index: '/api/insureapi/officialQaIndexService/index',
  qa_latestArticle: '/api/insureapi/officialQaIndexService/latestArticle',
  qa_nearbyArticle: '/api/insureapi/officialQaIndexService/nearbyArticle',
  qa_preView: '/api/insureapi/officialQaIndexService/preViewQaDetail',
  qa_relatedArticle: '/api/insureapi/officialQaIndexService/relatedArticle',
  qa_searchArticle: '/api/insureapi/officialQaIndexService/searchArticle',
  qa_tagArticleList: '/api/insureapi/officialQaIndexService/tagArticleList',
  qa_yourFavirite: '/api/insureapi/officialQaIndexService/yourFavorite',
  // 专题
  su_detail: '/api/insureapi/officialSpecialSubIndexService/specialSubDetail',
  su_preview: '/api/insureapi/officialSpecialSubIndexService/preViewSpecialSubDetail',
  su_getDetailByIds: '/api/insureapi/officialSpecialSubIndexService/getDetailByIds',
  su_categoryArticle: '/api/insureapi/officialSpecialSubIndexService/categoryArticle',
  su_hotArticle: '/api/insureapi/officialSpecialSubIndexService/hotArticle',
  su_hotTag: '/api/insureapi/officialSpecialSubIndexService/hotTag',
  su_index: '/api/insureapi/officialSpecialSubIndexService/index',
  su_latestArticle: '/api/insureapi/officialSpecialSubIndexService/latestArticle',
  su_nearbyArticle: '/api/insureapi/officialSpecialSubIndexService/nearbyArticle',
  su_preView: '/api/insureapi/officialSpecialSubIndexService/preViewQaDetail',
  su_relatedArticle: '/api/insureapi/officialSpecialSubIndexService/relatedArticle',
  su_searchArticle: '/api/insureapi/officialSpecialSubIndexService/searchArticle',
  su_tagArticleList: '/api/insureapi/officialSpecialSubIndexService/tagArticleList',
  su_yourFavirite: '/api/insureapi/officialSpecialSubIndexService/yourFavorite'
}

export default [
	{
		name: 'articleDetail',
		method: 'POST',
		desc: '文章详情',
		path: '/insureapi/officialIndexService/articleDetail'
	},
	{
		name: 'categoryArticle',
		method: 'POST',
		desc: '栏目文章',
		path: '/insureapi/officialIndexService/categoryArticle'
	},
	{
		name: 'hotArticle',
		method: 'POST',
		desc: '热门推荐',
		path: '/insureapi/officialIndexService/hotArticle'
	},
	{
		name: 'hotTag',
		method: 'POST',
		desc: '热门标签',
		path: '/insureapi/officialIndexService/hotTag'
	},
	{
		name: 'index',
		method: 'POST',
		desc: '首页文章',
		path: '/api/insureapi/officialIndexService/index'
	},
	{
		name: 'indexCategory',
		method: 'POST',
		desc: '频道栏目',
		path: '/insureapi/officialIndexService/indexCategory'
	},
	{
		name: 'searchArticle',
		method: 'POST',
		desc: '搜索',
		path: '/insureapi/officialIndexService/searchArticle'
	},
	{
		name: 'latestArticle',
		method: 'POST',
		desc: '最新文章',
		path: '/insureapi/officialIndexService/latestArticle'
	},
	{
		name: 'newTagList',
		method: 'POST',
		desc: '最新标签',
		path: '/insureapi/officialIndexService/newTagList'
	},
	{
		name: 'relatedArticle',
		method: 'POST',
		desc: '相关文章',
		path: '/insureapi/officialIndexService/relatedArticle'
	},
	{
		name: 'yourFavorite',
		method: 'POST',
		desc: '猜你喜欢',
		path: '/insureapi/officialIndexService/yourFavorite'
	},
	{
		name: 'categoryTree',
		method: 'POST',
		desc: '栏目列表',
		path: '/insureapi/officialIndexService/categoryTree'
	},
	{
		name: 'nearbyArticle',
		method: 'POST',
		desc: '上下篇',
		path: '/insureapi/officialIndexService/nearbyArticle'
	},
	{
		name: 'tagArticleList',
		method: 'POST',
		desc: '标签文章列表',
		path: '/insureapi/officialIndexService/tagArticleList'
	},
	{
		name: 'preViewArticleDetail',
		method: 'POST',
		desc: '文章预览',
		path: '/insureapi/officialIndexService/preViewArticleDetail'
	},
	{
		name: 'hotSearch',
		method: 'POST',
		desc: '热门搜索',
		path: '/insureapi/officialIndexService/hotSearch'
	},
	{
		name: 'pageInfo',
		method: 'POST',
		desc: '热门搜索',
		path: '/insureapi/officialIndexService/pageInfo'
	}
];
